export default __webpack_public_path__ + "static/img/img_4.6b4dd94.png";